import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { StepEquipmentModel } from '../../models/stepEquipment';
import { resetRecipeSteps } from './recipeStepsReset';

interface StepsEquipmentState {
  steps: StepEquipmentModel[];
}

const initialState: StepsEquipmentState = {
  steps: []
};

const stepsEquipmentSlice = createSlice({
  name: 'stepsEquipment',
  initialState,
  reducers: {
    setStepsEquipment(state, action: PayloadAction<StepEquipmentModel[]>) {
      state.steps = action.payload;
    },
    addStepEquipment(state, action: PayloadAction<StepEquipmentModel>) {
      state.steps.push(action.payload);
    },
    removeStepEquipment(state, action: PayloadAction<number>) {
      state.steps = state.steps.filter(step => step.id !== action.payload);
    },
    removeStepEquipmentAtIndex(state, action: PayloadAction<number>) {
      state.steps.splice(action.payload, 1);
    },
    updateStepEquipment(state, action: PayloadAction<{ index: number; changes: Partial<StepEquipmentModel> }>) {
      const { index, changes } = action.payload;
      const step = state.steps[index];
      if (step) state.steps[index] = { ...step, ...changes };
    },
    clearStepsEquipment(state) {
      state.steps = [];
    }
  },
  extraReducers: builder => {
    builder.addCase(resetRecipeSteps, (state, action) => {
      state.steps = action.payload.stepEquipment;
    });
  }
});

export const {
  setStepsEquipment,
  addStepEquipment,
  removeStepEquipment,
  removeStepEquipmentAtIndex,
  updateStepEquipment,
  clearStepsEquipment
} = stepsEquipmentSlice.actions;

export default stepsEquipmentSlice.reducer;
